<template>
  <div class="dm-map">
    <GmapMap
      :center="mapOptions.position"
      :zoom="mapOptions.zoom"
      map-type-id="terrain"
      :options="{ gestureHandling: 'cooperative' }"
      ref="map"
    >
      <GmapCluster :styles="clusterStyle" :zoomOnClick="true">
        <GmapMarker
          :key="dealer.id"
          v-for="dealer in allDealers"
          :position="
            google &&
            new google.maps.LatLng(dealer.Position.Lat, dealer.Position.Lng)
          "
          :icon="getMarker(dealer.Categories)"
          :clickable="true"
          :draggable="false"
          @click="clickMarker(dealer)"
          :zIndex="10"
        />
      </GmapCluster>
      <GmapMarker
        v-if="activeDealer !== null"
        :position="
          google &&
          new google.maps.LatLng(
            activeDealer.Position.Lat,
            activeDealer.Position.Lng
          )
        "
        :icon="getActiveMarker(activeDealer.Categories)"
        :clickable="true"
        :draggable="false"
        @click="clickMarker(activeDealer)"
        :zIndex="20"
      />
    </GmapMap>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';

export default {
  name: 'ComponentMap',
  data() {
    return {
      active: this.activeDealer,
      clusterStyle: [
        {
          textColor: this.clusterTextColor,
          url: this.assetsFolder + '/cluster_marker.png ',
          height: 50,
          width: 50
        }
      ]
    };
  },
  props: {
    allDealers: Array,
    foundDealers: Array,
    activeDealer: Object,
    mapOptions: Object,
    homePosition: Object,
    assetsFolder: String,
    defaultCountry: String,
    clusterTextColor: String
  },
  computed: {
    google: gmapApi
  },
  methods: {
    clickMarker(d) {
      this.active = d;
      this.$emit('update:activeDealer', this.active);
    },
    getMarker(name) {
      if (name && name[0] && name[0].CodeName) {
        return this.assetsFolder + '/marker_' + name[0].CodeName + '.png';
      } else {
        return this.assetsFolder + '/marker.png';
      }
    },
    getActiveMarker(name) {
      if (name && name[0] && name[0].CodeName) {
        return (
          this.assetsFolder + '/active_marker_' + name[0].CodeName + '.png'
        );
      } else {
        return this.assetsFolder + '/active_marker.png';
      }
    }
  },
  watch: {
    allDealers(allDealers) {
      this.$refs.map.$mapPromise.then(() => {
        if (this.foundDealers.length === 0) {
          if (this.defaultCountry === 'NL') {
            // eslint-disable-next-line vue/no-mutating-props
            this.mapOptions.zoom = 8;
            // eslint-disable-next-line vue/no-mutating-props
            this.mapOptions.position = { lat: 52.2129919, lng: 5.2793703 };
          } else if (this.defaultCountry === 'DE') {
            // eslint-disable-next-line vue/no-mutating-props
            this.mapOptions.zoom = 7;
            // eslint-disable-next-line vue/no-mutating-props
            this.mapOptions.position = { lat: 51.1642292, lng: 10.4541194 };
          } else if (this.defaultCountry === 'BE') {
            // eslint-disable-next-line vue/no-mutating-props
            this.mapOptions.zoom = 9;
            // eslint-disable-next-line vue/no-mutating-props
            this.mapOptions.position = { lat: 50.5010789, lng: 4.4764595 };
          } else if (this.defaultCountry === 'UK') {
            // eslint-disable-next-line vue/no-mutating-props
            this.mapOptions.zoom = 6;
            // eslint-disable-next-line vue/no-mutating-props
            this.mapOptions.position = { lat: 55.3617609, lng: -3.4433238 };
          } else if (this.defaultCountry === 'INT') {
            // eslint-disable-next-line no-undef
            const bounds = new google.maps.LatLngBounds();
            for (let dealer of allDealers) {
              bounds.extend(
                // eslint-disable-next-line no-undef
                new google.maps.LatLng(dealer.Position.Lat, dealer.Position.Lng)
              );
            }
            this.$refs.map.fitBounds(bounds);
            // eslint-disable-next-line vue/no-mutating-props
            this.mapOptions.zoom = 3;
          } else if (allDealers.length > 1) {
            // eslint-disable-next-line no-undef
            const bounds = new google.maps.LatLngBounds();
            for (let dealer of allDealers) {
              bounds.extend(
                // eslint-disable-next-line no-undef
                new google.maps.LatLng(dealer.Position.Lat, dealer.Position.Lng)
              );
            }
            this.$refs.map.fitBounds(bounds);
          }
        }
      });
    },
    foundDealers(foundDealers) {
      this.$refs.map.$mapPromise.then(() => {
        if (foundDealers.length > 0) {
          // eslint-disable-next-line no-undef
          const bounds = new google.maps.LatLngBounds();
          for (let dealer of foundDealers) {
            bounds.extend(
              // eslint-disable-next-line no-undef
              new google.maps.LatLng(dealer.Position.Lat, dealer.Position.Lng)
            );
          }
          // check if home is within coordinate bounds
          if (
            this.homePosition.lat >= -90 &&
            this.homePosition.lat <= 90 &&
            this.homePosition.lat >= -180 &&
            this.homePosition.lat <= 180
          ) {
            bounds.extend(
              // eslint-disable-next-line no-undef
              new google.maps.LatLng(
                this.homePosition.lat,
                this.homePosition.lng
              )
            );
          }
          this.$refs.map.fitBounds(bounds);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.dm-map {
  width: 100%;
  position: relative;

  .vue-map-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;

    @media (max-width: 991.98px) {
      position: static;
      top: auto;
      right: auto;
      bottom: auto;
      left: auto;
      width: 100% !important;
      height: 720px !important;
    }

    @media (max-width: 767.98px) {
      height: 290px !important;
    }

    .vue-map {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: absolute;
    }
  }
}
</style>

